import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnModelerState } from './bpmn-modeler-state.selector';
import { CommandStackAction } from '@ispm/shared/bpmn-io/commandstack-action';

export const unsavedUserInitiatedActions: MemoizedSelector<object, CommandStackAction[]> =
    createSelector(selectBpmnModelerState, state => state.userInitiatedActions);

export const lastUnsavedUserInitiatedAction: MemoizedSelector<object, CommandStackAction> = 
    createSelector(unsavedUserInitiatedActions, actions => actions.length && actions[actions.length - 1] || undefined);

export const lastUnsavedUserInitiatedActionId: MemoizedSelector<object, number> = 
    createSelector(lastUnsavedUserInitiatedAction, action => action && action.id || undefined);